import React from 'react';
import PropTypes from 'prop-types';

export default class AddStudy extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor() {
    super();
    this.state = {
      data: JSON.parse(localStorage.getItem('add-study')),
      patients: [],
      company_id: '',
      study_type_id: '',
      patient_name: '',
    };
  }

  create() {
    let { patient_name, company_id, study_type_id } = this.state;
    if (!patient_name || !company_id || !study_type_id) return;
    this.props.addPatient({ patient_name, company_id, study_type_id });
    this.setState({
      patient_name: '',
      company_id: '',
      study_type_id: '',
    });
  }

  render() {
    let {
      patient_name,
      company_id,
      study_type_id,
    } = this.state;
    let { types, companies } = this.props.data;
    if (!types || !companies) return null;
    return (
      <div id="addstudy">
        <div id="info" />
        <div id="actionbar">

          <div id="fields">

            <select
              id="study_type"
              value={study_type_id}
              onChange={e => this.setState({
                study_type_id: parseInt(e.target.value, 10),
              })}
            >
              <option value="">Select Type</option>
              {types.map(type => (
                <option key={type.id} value={type.id}>{type.name}</option>
              ))}
            </select>

            <select
              id="study_company"
              value={company_id}
              onChange={e =>
                this.setState({ company_id: parseInt(e.target.value, 10) })}
            >
              <option value="">Select Company</option>
              {companies.map(company => (
                <option key={company.id} value={company.id}>
                  {company.name}
                </option>
              ))}
            </select>

            <input
              id="study_patient"
              type="text"
              value={patient_name}
              placeholder="Patient"
              onKeyUp={e =>
                e.keyCode === 13 && patient_name ? this.create() : null}
              onChange={e => this.setState({ patient_name: e.target.value })}
            />
            {patient_name && company_id && study_type_id
              ? <div onClick={() => this.create()} id="add_study_add">
                  Add
                </div>
              : null}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/add/new.js